export const catchMeGameId = 141426;
export const touchMeGameId = 63;

export const gameNameDependGameIds = {
  [catchMeGameId]: 'catchme',
  [touchMeGameId]: 'touchme',
};
export const defaultLanguageNameDependGameIds = {
  [catchMeGameId]: 'catchMeDefaultLanguage.json',
  [touchMeGameId]: 'touchMeDefaultLanguage.json',
};

export const specificLocalStorageKeys = {
  isMultiplierPopUpSeen: 'isMultiplierPopUpSeen',
};
